import React from 'react';
import AuditLogList from '../Logs/AuditLogList';
import { getSecurityLogs } from '../../services/logsecurityService';

const LogSecurityList: React.FC = () => <AuditLogList kind="security" loadLogs={getSecurityLogs} />;

export default LogSecurityList;

